<template>
  <div class="menu">
    <router-link to="/">
      <Icon class="menu__icon" name="/base/home.svg" />
    </router-link>
    <router-link
      v-for="(item, index) in menu"
      class="menu__item"
      :class="{ active: isActive(item) }"
      :to="item.url"
      :key="`menu-${index}`"
    >
      {{ item.title }}
    </router-link>
  </div>
</template>

<script>
import Icon from '@/components/Base/Icon/Icon.vue'
import { PURCHASE_PATHS } from '@/utils/purchase'

export default {
  name: 'Menu',
  components: { Icon },
  computed: {
    menu() {
      const menu = [
        { title: this.$t('navigation.buyRobux'), url: { path: PURCHASE_PATHS.transfer } },
        { title: this.$t('navigation.gift'), url: { path: PURCHASE_PATHS.gift } },
        { title: this.$t('navigation.superPass'), url: { path: PURCHASE_PATHS.superPass } }
      ]

      // Логпасс может быть выключен у поставщика — тогда пункта нет.
      if (this.$store.getters.isPacksAvailable) {
        menu.push({ title: this.$t('navigation.packs'), url: { path: PURCHASE_PATHS.packs } })
      }

      return menu
    }
  },
  methods: {
    // Витрины различаются путём, query (utm, robux) на подсветку не влияет
    isActive(item) {
      return this.$route.path === item.url.path
    }
  }
}
</script>
<style lang="scss" scoped>
@import './menu';
</style>
